import { FormlyFieldConfig } from '@ngx-formly/core';
import {
  IBaseConfigurationFormModel,
  IFormbuilderFieldTypeConfiguration,
} from '../../../models/form-builder-types-configurations.model';
import {
  generateNewFieldKeyFromSettingsLabel,
  getFieldKeySettingsConfigFormly,
  getFieldLabelSettingsConfigFormly,
  getPlaceholderSettingsConfigFormly,
} from '../form-fields-formly-settings/form-builder-default-settings-configuration-formly-fields.utils';
import { FormBuilderService } from '../../../services/form-builder.service';
import { getFieldDisplayFormConfig } from '../form-fields-formly-display/form-fields-formly-display-field-generator.util';
import { IFormFieldsDisplayModel } from '../../../models/form-fields-formly-display.model';
import { parseFieldIntoDisplayFormModel } from '../form-fields-formly-display/form-fields-formly-display-field-parse-to-model.util';
import { setDisplayHideExpressionFromModel } from '../form-fields-formly-display/form-fields-formly-display-field-set-from-model.util';

const defaultBlockConfigFormModel: IBaseConfigurationFormModel = {
  fieldKey: '',
  fieldLabel: null,
  placeholder: null,
};

export const blockFieldGetConfigurationConfig = (
  formBuilderServiceInstance: FormBuilderService
): IFormbuilderFieldTypeConfiguration => {
  return {
    settings: {
      formModel: defaultBlockConfigFormModel,
      formlyForm: [
        ...getFieldLabelSettingsConfigFormly(formBuilderServiceInstance),
        ...getPlaceholderSettingsConfigFormly(),
        ...getFieldKeySettingsConfigFormly(formBuilderServiceInstance),
      ],
    },
    display: {
      formModel: {},
      formlyForm: [...getFieldDisplayFormConfig(formBuilderServiceInstance)],
    },
  };
};

export const blockFieldParseIntoSettingsFormModel = (
  field: FormlyFieldConfig
): IBaseConfigurationFormModel => {
  const model: IBaseConfigurationFormModel = {
    fieldKey: (field.key as string) ?? '',
    placeholder: field.props?.placeholder ?? '',
    fieldLabel: field.props?.label ?? '',
  };

  return model;
};

export const blockFieldUpdateFromSettingsFormModel = (
  model: IBaseConfigurationFormModel,
  blockField: FormlyFieldConfig
): FormlyFieldConfig => {
  if (blockField.props) {
    blockField.props['placeholder'] = model.placeholder ?? undefined;
    blockField.props['label'] = model.fieldLabel ?? undefined;
  } else {
    blockField['props'] = {
      label: model.fieldLabel ?? undefined,
      placeholder: model.placeholder ?? undefined,
    };
  }

  // Handle field key update
  if (model.fieldKey && model.fieldKey.trim() !== '') {
    // Use the provided field key
    blockField.key = model.fieldKey.trim();
  } else if (
    !blockField.key ||
    model.fieldLabel !== blockField.props?.['label']
  ) {
    // Auto-generate key from label if no key provided or label changed
    blockField = generateNewFieldKeyFromSettingsLabel(blockField);
  }

  return blockField;
};

export const blockFieldParseFieldIntoDisplayFormModel = (
  field: FormlyFieldConfig
): IFormFieldsDisplayModel => {
  return parseFieldIntoDisplayFormModel(field);
};

export const blockFieldUpdateFromDisplayFormModel = (
  model: IFormFieldsDisplayModel,
  field: FormlyFieldConfig
): FormlyFieldConfig => {
  return setDisplayHideExpressionFromModel(model, field);
};
